const AppointmentStatus = {
  NEW: 'new',
  STARTED: 'started',
  COMPLETED: 'completed',
  NO_SHOW: 'no-show'
};

export default AppointmentStatus;
